import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { BackLogoIconButton } from "../../../../../reusableComponents/smallReusableComponent/LoginTopLogoAndText";
import { TopTextReusableComponent } from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/TopTextReusable/TopTextReusableComponent";
import {
  ReusableOnboardingButton,
  ReusableOnboardingLink,
} from "../../../../../vendorOnboradingComponents/reusableOnboardingComponent/ButtonReusable/ReusableOnboardingButton";
import { ToggleButtonWithYesNo } from "../../AllButton/ToggleButtonReuse";
import {
  NewInputText,
  SelectBoxMUiInputComponent,
} from "../../../../../reusableComponents/inputReusableComponent/InputBoxComponent";
import InputNumberFunc from "../../../../../../function/InputNumberFunc";
import { FormControl, Select, InputLabel, MenuItem } from "@material-ui/core";
import KeyboardArrowDownIcon from "@material-ui/icons/KeyboardArrowDown";
import { useFormik } from "formik";
import * as yup from "yup";
import Alert from "react-s-alert";
import LeftSideNavigation from "../../../../navigationSection/LeftSideNavigation";
import { TopNavigationBarMobile } from "../../../../navigationSection/TopNavigationBarMobile";
import RightSideNavigation from "../../../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../../navigationSection/BottomNavigationMobile";

import PropTypes from "prop-types";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { update_new_subscription_for_vendor } from "../../../../../../store/actions/authAction";
import { SliderReusableComponent } from "../../../../../reusableComponents/sliderReusableComponent/SliderReusableComponent";
import isEmpty from "../../../../../../store/validation/is-Empty";
import { AmealioLoader } from "../../../../../Loader/AmealioLoader";
import { MobileTopHeader } from "../../../../../reusableComponents/sliderReusableComponent/MobileTopHeader";
import Media from "react-media";
import { Button, Image } from "react-bootstrap";
import { ACCESSIBILITY_TYPE } from "../../../../../../store/types";

const validationSchema = yup.object({
  auto_accept_pax: yup.number().required("auto pax is required"),
});

export const OfflineEventsEditSubscription = (props) => {
  let history = useHistory();
  const [state, setState] = useState({
    editButton: false,
  });
  // const validate = (values) => {
  //   const errors = {};
  //   if (formik.values.rsvpEnabled) {
  //     if (formik.touched.distance && !formik.values.distance) {
  //       errors.distance = "distance is required";
  //     }
  //     if (formik.touched.request_period && !formik.values.request_period) {
  //       errors.request_period = "request period is required";
  //     }
  //     if (formik.touched.min_person && !formik.values.min_person) {
  //       errors.min_person = "mimimum person is required";
  //     }
  //     if (formik.values.min_person === 0) {
  //       errors.min_person = "at least 1 mimimum person is required";
  //     }
  //     if (formik.touched.rsvp_kept_for && !formik.values.rsvp_kept_for) {
  //       errors.rsvp_kept_for = "rsvp kept is required";
  //     }
  //   }
  //   if (formik.values.kids_allowed) {
  //     if (formik.touched.min_age && !formik.values.min_age) {
  //       errors.distance = "minimum age is required";
  //     }
  //   }
  //   return errors;
  // };

  const [activeAccount, setActiveAccount] = useState();

  const formik = useFormik({
    initialValues: {
      highchair: false,
      handicap: false,
      room_number_on_request: false,
      auto_accept_pax: "",
      kids_allowed: false,
      min_age: "",
      booking_enabled: false,
      seat_selection_applicable: false,
      addedAccounts: [],
      user_template: false,
      rsvpEnabled: true,
      distance: "",
      request_period: "",
      min_person: 1,
      rsvp_kept_for: "",
      auto_cancel: "",
      tableSeatManagement: false,
    },
    validationSchema,
    // validate,

    onSubmit: (values) => {
      let valuesData = {
        value:
          values.highchair === false &&
          values.handicap === false &&
          values.room_number_on_request === false &&
          values.auto_accept_pax === "" &&
          values.kids_allowed === false &&
          values.min_age === "" &&
          values.booking_enabled === false &&
          values.seat_selection_applicable === false &&
          values.user_template === false &&
          values.rsvpEnabled === true &&
          values.distance === "" &&
          values.request_period === "" &&
          values.min_person === "" &&
          values.rsvp_kept_for === "" &&
          values.auto_cancel === "" &&
          values.tableSeatManagement === false
            ? false
            : true,
        highchair: values.highchair,
        handicap: values.handicap,
        room_number_on_request: values.room_number_on_request,
        auto_accept_pax: values.auto_accept_pax,
        kids_allowed: {
          value: values.kids_allowed,
          min_age: values.min_age,
        },
        booking_enabled: {
          value: values.booking_enabled,
          addedAccounts: activeAccount,
        },
        seat_selection_applicable: values.seat_selection_applicable,
        user_template: values.user_template,
        rsvp: {
          value: values.rsvpEnabled,
          distance: {
            value: false,
            distance: values.distance,
            request_period: values.request_period,
            min_person: values.min_person,
            rsvp_kept_for: values.rsvp_kept_for,
            auto_cancel: values.auto_cancel,
          },
        },
        seat_management: {
          value: values.tableSeatManagement,
        },
      };
      const token = props.auth.user.accessToken;
      const subscriptionId = props.subscription._id;
      let formData = props.allSubscriptionsData;
      if (props?.casualDiningService) {
        formData.casual_dining_status.event_management.offline_event =
          valuesData;
      } else if (props?.multiDiningService) {
        formData.multi_service_business_status.event_management.offline_event =
          valuesData;
      }

      if (valuesData.rsvp.value !== true) {
        Alert.error(
          "<h4>Please enable RSVP and also fill all RSVP information</h4>",
          {
            position: "top-right",
            effect: "bouncyflip",
            beep: true,
            html: true,
            timeout: 3000,
            offset: 35,
          }
        );
      } else {
        props.update_new_subscription_for_vendor(
          subscriptionId,
          formData,
          token,
          onSuccess
        );
      }
    },
  });

  const onSuccess = (e) => {
    Alert.success("<h4>Offline event changes add successfully</h4>", {
      position: "top-right",
      effect: "bouncyflip",
      beep: true,
      html: true,
      timeout: 3000,
      offset: 35,
    });
    history.push("/edit-event-subscription");
  };

  // useEffect(() => {
  //   formik.setFieldValue("auto_accept_pax", "");
  // }, []);

  const [count, setCount] = useState(1);
  const onClickSave = () => {
    setCount(count + 1);
    formik.handleSubmit();
  };

  useEffect(() => {
    if (formik.errors && formik.errors.auto_accept_pax) {
      let auto_accept_paxElement = document.getElementById("auto_accept_pax");
      auto_accept_paxElement.focus();
    }
    // else if (formik1.errors && formik1.errors.templateMessage) {
    //   let templateMessageElement = document.getElementById("templateMessage");
    //   templateMessageElement.focus();
    // }
  }, [count]);

  const maxLengthCheck = (object) => {
    if (object.target.value.length > object.target.maxLength) {
      object.target.value = object.target.value.slice(
        0,
        object.target.maxLength
      );
    }
  };

  const enableSeatSelection = () => {
    if (formik.values.booking_enabled === true) {
      formik.setFieldValue(
        "seat_selection_applicable",
        !formik.values.seat_selection_applicable
      );
    } else {
      Alert.error("<h4>Please enable event ticket booking</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    }
  };

  const enableBooking = (access) => {
    if (formik.values.booking_enabled === true) {
      formik.setFieldValue("booking_enabled", !formik.values.booking_enabled);
      formik.setFieldValue("seat_selection_applicable", false);
    } else {
      const token = props.auth.user.accessToken;
      const subscriptionId = props?.subscription && props?.subscription?._id;
      let formData = props.allSubscriptionsData;
      if (props?.casualDiningService) {
        formData.casual_dining_status.event_management.offline_event =
          formik.values;
        formData.casual_dining_status.event_management.offline_event.kids_allowed =
          {
            value: formik.values.kids_allowed,
            min_age: formik.values.min_age,
          };
        formData.casual_dining_status.event_management.offline_event.booking_enabled =
          {
            value: formik.values.booking_enabled,
            addedAccounts: activeAccount,
          };
        formData.casual_dining_status.event_management.offline_event.seat_selection_applicable =
          formik.values.seat_selection_applicable;
        formData.casual_dining_status.event_management.offline_event.rsvp = {
          value: formik.values.rsvpEnabled,
          distance: {
            value: false,
            distance: formik.values.distance,
            request_period: formik.values.request_period,
            min_person: formik.values.min_person,
            rsvp_kept_for: formik.values.rsvp_kept_for,
            auto_cancel: formik.values.auto_cancel,
          },
        };
        formData.casual_dining_status.event_management.offline_event.seat_management =
          {
            value: formik.values.tableSeatManagement,
          };
      } else if (props?.multiDiningService) {
        formData.multi_service_business_status.event_management.offline_event =
          formik.values;
        formData.multi_service_business_status.event_management.offline_event.kids_allowed =
          {
            value: formik.values.kids_allowed,
            min_age: formik.values.min_age,
          };
        formData.multi_service_business_status.event_management.offline_event.booking_enabled =
          {
            value: formik.values.booking_enabled,
            addedAccounts: activeAccount,
          };
        formData.multi_service_business_status.event_management.offline_event.seat_selection_applicable =
          formik.values.seat_selection_applicable;
        formData.multi_service_business_status.event_management.offline_event.rsvp =
          {
            value: formik.values.rsvpEnabled,
            distance: {
              value: false,
              distance: formik.values.distance,
              request_period: formik.values.request_period,
              min_person: formik.values.min_person,
              rsvp_kept_for: formik.values.rsvp_kept_for,
              auto_cancel: formik.values.auto_cancel,
            },
          };
        formData.multi_service_business_status.event_management.offline_event.seat_management =
          {
            value: formik.values.tableSeatManagement,
          };
      }
      props.update_new_subscription_for_vendor(
        subscriptionId,
        formData,
        token,
        () => bookingSuccess(access)
      );
      // console.log(formData);
    }
  };

  const bookingSuccess = (access) => {
    history.push({
      pathname:
        "/edit-event-subscription/edit-event-offline-subscription/ticketbooking",
      state: { access: access },
    });
  };

  const enableRsvp = () => {
    if (formik.values.rsvpEnabled) {
      Alert.error("<h4>You can't disabled RSVP</h4>", {
        position: "top-right",
        effect: "bouncyflip",
        beep: true,
        html: true,
        timeout: 3000,
        offset: 35,
      });
    } else {
      formik.setFieldValue("rsvpEnabled", !formik.values.rsvpEnabled);
    }
    formik.errors = {};
  };

  useEffect(() => {
    if (props && props.subscriptionData) {
      let data = props.subscriptionData;
      formik.setFieldValue("highchair", data.highchair);
      formik.setFieldValue("handicap", data.handicap);
      formik.setFieldValue(
        "room_number_on_request",
        data.room_number_on_request
      );
      formik.setFieldValue("auto_accept_pax", data.auto_accept_pax);
      formik.setFieldValue("kids_allowed", data.kids_allowed.value);
      formik.setFieldValue("min_age", data.kids_allowed.min_age);
      formik.setFieldValue("booking_enabled", data.booking_enabled.value);
      formik.setFieldValue(
        "seat_selection_applicable",
        data.seat_selection_applicable
      );
      formik.setFieldValue("auto_cancel", data.rsvp.distance.auto_cancel);
      formik.setFieldValue("user_template", data.user_template);
      formik.setFieldValue("rsvpEnabled", data.rsvp.value);
      formik.setFieldValue("distance", data.rsvp.distance.distance);
      formik.setFieldValue("request_period", data.rsvp.distance.request_period);
      formik.setFieldValue("min_person", data.rsvp.distance.min_person);
      formik.setFieldValue("rsvp_kept_for", data.rsvp.distance.rsvp_kept_for);
      formik.setFieldValue("tableSeatManagement", data.seat_management.value);
      setActiveAccount(data.booking_enabled.addedAccounts);
    }
  }, [props.subscriptionData]);

  const [disabled, setDisable] = useState(
    props?.history?.location?.state?.access === "view" ? true : false
  );

  if (props.auth.loader === true) {
    return (
      <React.Fragment>
        <AmealioLoader />
      </React.Fragment>
    );
  } else {
    return (
      <React.Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="left-side-panel">
              <LeftSideNavigation />
            </div>
            <div className="top-panel">
              <TopNavigationBarMobile displayLeft="logo" />
            </div>
            <div className="right-side-panel">
              <RightSideNavigation
                leftText="vendorReview"
                backButtonLink="/edit-event-subscription"
                displayText="Back"
              />
              <div className="col-9 col-md-6 bg-transparent pt-md-0 pt-lg-0 pt-xl-0">
                <div className=" p-0">
                  <div className="mb-4">
                    <TopTextReusableComponent
                      headingText="Offline Event Management"
                      headingParagraph="(Note: Events are in a physical venue and accept RSVP)"
                      // displayEdit={state.editButton}
                      // onClickEdit={editClick}
                    />
                  </div>
                </div>
                <div className="inside-event-offline-online-text">
                  <div className="f20-700 py-3">
                    Do you provide services for the following at the Events?
                  </div>
                  <div className="row margin-between-toggler mb-3">
                    <div className="col-8">
                      <div>
                        <div className="f15-500">Highchair</div>
                        <p className="left-toggle-bottom-text-head"></p>
                      </div>
                    </div>
                    <div className="col-4">
                      <ToggleButtonWithYesNo
                        activeClass={formik.values.highchair}
                        checkedBox={formik.values.highchair}
                        onChange={() =>
                          formik.setFieldValue(
                            "highchair",
                            !formik.values.highchair
                          )
                        }
                        disabled={disabled}
                        extraClass="d-flex align-items-center"
                        extraYesNo="f12-500"
                      />
                    </div>
                  </div>
                  <div className="row margin-between-toggler mb-3">
                    <div className="col-8">
                      <div className="f15-500">Handicap Access</div>
                    </div>
                    <div className="col-4">
                      <ToggleButtonWithYesNo
                        activeClass={formik.values.handicap}
                        checkedBox={formik.values.handicap}
                        onChange={() =>
                          formik.setFieldValue(
                            "handicap",
                            !formik.values.handicap
                          )
                        }
                        disabled={disabled}
                        extraClass="d-flex align-items-center"
                        extraYesNo="f12-500"
                      />
                    </div>
                  </div>
                  <div className="row margin-between-toggler mb-3">
                    <div className="col-8">
                      <div className="f15-500">
                        Room number on Seating Request?
                      </div>
                      <div className="f11-400 opacity5">
                        (This may be relevant if you located inside a
                        hotel/resort)
                      </div>
                    </div>
                    <div className="col-4">
                      <ToggleButtonWithYesNo
                        activeClass={formik.values.room_number_on_request}
                        checkedBox={formik.values.room_number_on_request}
                        onChange={() =>
                          formik.setFieldValue(
                            "room_number_on_request",
                            !formik.values.room_number_on_request
                          )
                        }
                        disabled={disabled}
                        extraClass="d-flex align-items-center"
                        extraYesNo="f12-500"
                      />
                    </div>
                  </div>
                  <div className="row margin-between-toggler mb-3">
                    <div className="col-8">
                      <div className="f15-500">Auto Accept Pax Limit</div>
                      <div className="f11-400 opacity5">
                        (Request with pax below this will automatically be
                        accepted for RSVP, any number above this threshold will
                        go to pending for action)
                      </div>
                    </div>
                    <div className="col-4">
                      <div className="row align-items-center">
                        <div className="col-8 p-0">
                          <NewInputText
                            extraClass="mb-1"
                            name="auto_accept_pax"
                            maxLength={5}
                            onKeyPress={(event) => {
                              if (!/[0-9]/.test(event.key)) {
                                event.preventDefault();
                              }
                            }}
                            onInput={maxLengthCheck}
                            inputType="number"
                            onKeyDown={InputNumberFunc}
                            onFocusOut={formik.handleBlur}
                            onChange={formik.handleChange}
                            value={formik.values.auto_accept_pax}
                            controlClass="auto_accept_pax"
                            disabled={disabled}
                          />
                        </div>
                        <div className="col-4">
                          <p className="f12-400">Pax</p>
                        </div>
                        <div className="col-8">
                          {formik.errors.auto_accept_pax &&
                          formik.touched.auto_accept_pax ? (
                            <div className="pho_14_regular text-danger">
                              {formik.errors.auto_accept_pax}
                            </div>
                          ) : null}
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="col-12 p-0 margin-between-toggler">
                    <div className="f20-700 pt-3">Kids Allowed ?</div>
                    <div className="f11-400 opacity5">
                      (This may be relevant if you are a Bar and Night Club with
                      min age to enter, you may still have to check the ID for
                      the entrants)
                    </div>
                  </div>
                  <div className="row margin-between-toggler mt-3 align-items-center">
                    <div
                      className={
                        formik.values.kids_allowed === true
                          ? "col-md-3 col-5"
                          : "col-md-8"
                      }
                    >
                      <div className="f15-500">Kids Allowed</div>
                    </div>
                    <div
                      className={
                        formik.values.kids_allowed === true
                          ? "col-md-9 col-6"
                          : "col-4"
                      }
                    >
                      <div className="row align-items-center">
                        <div className="col-3">
                          <ToggleButtonWithYesNo
                            activeClass={formik.values.kids_allowed}
                            checkedBox={formik.values.kids_allowed}
                            onChange={() =>
                              formik.setFieldValue(
                                "kids_allowed",
                                !formik.values.kids_allowed
                              )
                            }
                            disabled={disabled}
                            extraClass="d-flex align-items-center"
                            extraYesNo="f12-500"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row my-2 ml-1">
                          {formik.values.kids_allowed === true ? (
                            <div className="row align-items-center">
                              <div className="col-5">
                                <p className="f15-500">Min Age for Entry</p>
                              </div>
                              <div className="col-5">
                                <FormControl
                                  variant="outlined"
                                  fullWidth
                                  className={"w-100"}
                                >
                                  <Select
                                    // label="Min Age for Entry"
                                    name="min_age"
                                    id="min_age"
                                    className={`w-100 ${
                                      formik.errors.min_age &&
                                      formik.touched.min_age
                                        ? "enError outlined-Minutes"
                                        : "outlined-Minutes"
                                    }`}
                                    disabled={disabled}
                                    onChange={formik.handleChange}
                                    value={formik.values.min_age}
                                    onBlur={formik.handleBlur}
                                    isInvalid={
                                      formik.errors.min_age &&
                                      formik.touched.min_age
                                    }
                                    // className="outlined-Minutes"
                                    IconComponent={KeyboardArrowDownIcon}
                                  >
                                    <MenuItem value={5}>age 5</MenuItem>
                                    <MenuItem value={10}>age 10</MenuItem>
                                    <MenuItem value={15}>age 15</MenuItem>
                                    <MenuItem value={20}>age 18</MenuItem>
                                  </Select>
                                </FormControl>
                              </div>
                              <div className="col-5"></div>
                              <div className="col-6">
                                {formik.errors.min_age &&
                                formik.touched.min_age ? (
                                  <div className="pho_14_regular text-danger">
                                    {formik.errors.min_age}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          ) : null}
                  </div>
                  <hr />
                  <div className="f20-700 pb-3 mt-0">
                    Events Other Subscription
                  </div>
                  <div className="row margin-between-toggler mb-3">
                    <div className="col-6">
                      <div className="f15-500">Booking Enabled</div>
                      <div className="f11-400 opacity5">
                        Enable this toggle to add bank details for ticket
                        booking of events
                      </div>
                    </div>
                    <div className="col-6 align-items-center">
                      <div>
                        <ToggleButtonWithYesNo
                          activeClass={formik.values.booking_enabled}
                          checkedBox={formik.values.booking_enabled}
                          onChange={() => enableBooking()}
                          extraClass="d-flex align-items-center"
                          extraYesNo="f12-500"
                          disabled={disabled}
                        />
                      </div>
                      <div
                        className="d-flex rightside-toggle-buttons-subscription-menu my-3"
                        // style={{ minWidth: "150px", marginLeft: "25px" }}
                      >
                        {/* {checkedBox && ( */}
                        <>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={
                              (e) => enableBooking("view")
                              //   {
                              //   history.push({
                              //     pathname:
                              //       "/edit-event-subscription/edit-event-offline-subscription",
                              //     state: { access: "view" },
                              //   });
                              // }
                            }
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/eye.svg")}
                              alt="View"
                              title="View"
                              fluid
                            />
                          </Button>
                          <Button
                            variant="link"
                            className="enIconBtn mr-3"
                            onClick={(e) => enableBooking("edit")}
                          >
                            <Image
                              src={require("../../../../../../assets/images/UserManagement/pencil.svg")}
                              alt="Edit"
                              title="Edit"
                              fluid
                            />
                          </Button>
                        </>
                        {/* )} */}
                      </div>
                    </div>
                    <div className="col-12 mt-4">
                      <div className="row">
                        <div className="col-8">
                          <div className="f15-700">Seat Selections Enabled</div>
                          <p className="f11-400 opacity5">
                            (Enable this toggle if you want to give seat
                            selection option to the user)
                          </p>
                        </div>
                        <div className="col-4">
                          <ToggleButtonWithYesNo
                            activeClass={
                              formik.values.seat_selection_applicable
                            }
                            disabled={disabled}
                            checkedBox={formik.values.seat_selection_applicable}
                            onChange={() => enableSeatSelection()}
                            extraClass="d-flex align-items-center"
                            extraYesNo="f12-500"
                          />
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="row margin-between-toggler mb-3">
                    <div className="col-8">
                      <div className="f15-500">User Templates for Design</div>
                    </div>
                    <div className="col-4">
                      <ToggleButtonWithYesNo
                        activeClass={formik.values.user_template}
                        checkedBox={formik.values.user_template}
                        onChange={() =>
                          formik.setFieldValue(
                            "user_template",
                            !formik.values.user_template
                          )
                        }
                        disabled={disabled}
                        extraClass="d-flex align-items-center"
                        extraYesNo="f12-500"
                      />
                    </div>
                  </div>
                  <div className="row margin-between-toggler mb-3">
                    <div className="col-8">
                      <div className="f15-500">RSVP Enabled</div>
                      <p className="f11-400 opacity5">
                        (RSVP is mandatory for all offline events and cannot be
                        disabled)
                      </p>
                    </div>
                    <div className="col-4">
                      <ToggleButtonWithYesNo
                        activeClass={formik.values.rsvpEnabled}
                        checkedBox={formik.values.rsvpEnabled}
                        onChange={() => enableRsvp()}
                        extraClass="d-flex align-items-center"
                        extraYesNo="f12-500"
                        disabled={formik.values.rsvpEnabled ? true : false}
                      />
                    </div>
                    {formik.values.rsvpEnabled ? (
                      <div className="col-12 p-4">
                        <h4 className="f20-700 rsvp-setting-text mt-3 mb-3">
                          RSVP Settings
                        </h4>
                        <div className="row margin-between-toggler mb-4">
                          <div className="col-7">
                            <div className="f15-500">Distance</div>
                            <div className="f11-400 opacity5 pr-2">
                              (Max Distance of user location from which they can
                              make Walk-in / Wait request)
                            </div>
                          </div>
                          <div className="col-5">
                            <div className="row align-items-center">
                              <div className="col-8 p-0">
                                <FormControl
                                  variant="outlined"
                                  className={"w-100"}
                                >
                                  <Select
                                    // label="Kilometers"
                                    name="distance"
                                    id="distance"
                                    className={`w-100 ${
                                      formik.errors.distance &&
                                      formik.touched.distance
                                        ? "enError outlined-Minutes"
                                        : "outlined-Minutes"
                                    }`}
                                    disabled={disabled}
                                    onChange={formik.handleChange}
                                    value={formik.values.distance}
                                    onBlur={formik.handleBlur}
                                    isInvalid={
                                      formik.errors.distance &&
                                      formik.touched.distance
                                    }
                                    // className="outlined-Minutes"
                                    IconComponent={KeyboardArrowDownIcon}
                                  >
                                    <MenuItem value={10000}>No Limit</MenuItem>
                                    <MenuItem value={50}>50 Kms</MenuItem>
                                    <MenuItem value={30}>30 Kms</MenuItem>
                                    <MenuItem value={20}>20 Kms</MenuItem>
                                    <MenuItem value={1}>1 Kms</MenuItem>
                                  </Select>
                                </FormControl>
                              </div>
                              <div className="col-4">
                                <p className="f12-500">Kilometers</p>
                              </div>
                              <div className="col-8">
                                {formik.errors.distance &&
                                formik.touched.distance ? (
                                  <div className="pho_14_regular text-danger">
                                    {formik.errors.distance}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row margin-between-toggler mb-4">
                          <div className="col-7">
                            <div className="f15-500">Request Period</div>
                            <div className="f11-400 opacity5 w-75">
                              ( Minimum period before arrival user can make a
                              request )
                            </div>
                          </div>
                          <div className="col-5">
                            <div className="row align-items-center">
                              <div className="col-8 p-0">
                                <FormControl
                                  variant="outlined"
                                  className={"w-100"}
                                >
                                  <Select
                                    // label="Minutes"
                                    name="request_period"
                                    id="request_period"
                                    className={`w-100 ${
                                      formik.errors.request_period &&
                                      formik.touched.request_period
                                        ? "enError outlined-Minutes"
                                        : "outlined-Minutes"
                                    }`}
                                    onChange={formik.handleChange}
                                    value={formik.values.request_period}
                                    onBlur={formik.handleBlur}
                                    isInvalid={
                                      formik.errors.request_period &&
                                      formik.touched.request_period
                                    }
                                    disabled={disabled}
                                    // className="outlined-Minutes"
                                    IconComponent={KeyboardArrowDownIcon}
                                  >
                                    <MenuItem value={10}>10 Minute</MenuItem>
                                    <MenuItem value={20}>20 Minute</MenuItem>
                                    <MenuItem value={30}>30 Minute</MenuItem>
                                    <MenuItem value={45}>45 Minute</MenuItem>
                                    <MenuItem value={60}>60 Minute</MenuItem>
                                  </Select>
                                </FormControl>
                              </div>
                              <div className="col-4">
                                <p className="f12-500">Minutes</p>
                              </div>
                              <div className="col-8">
                                {formik.errors.request_period &&
                                formik.touched.request_period ? (
                                  <div className="pho_14_regular text-danger">
                                    {formik.errors.request_period}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row margin-between-toggler mb-4">
                          <div className="col-7">
                            <div className="f15-700">Minimum Person</div>
                          </div>
                          <div className="col-5">
                            <div className="row align-items-center">
                              <div className="col-8 p-0">
                                <NewInputText
                                  extraClass="mb-1"
                                  name="min_person"
                                  maxLength={5}
                                  onKeyPress={(event) => {
                                    if (!/[0-9]/.test(event.key)) {
                                      event.preventDefault();
                                    }
                                  }}
                                  disabled={disabled}
                                  onInput={maxLengthCheck}
                                  inputType="number"
                                  onKeyDown={InputNumberFunc}
                                  onFocusOut={formik.handleBlur}
                                  onChange={formik.handleChange}
                                  value={formik.values.min_person}
                                  // labelText="Pax"
                                  controlClass="min_person"
                                />
                              </div>
                              <div className="col-4">
                                <p className="f12-500">Pax</p>
                              </div>
                              <div className="col-8">
                                {formik.errors.min_person &&
                                formik.touched.min_person ? (
                                  <div className="pho_14_regular text-danger">
                                    {formik.errors.min_person}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row margin-between-toggler mb-4">
                          <div className="col-7">
                            <div className="f15-500">RSVP is kept for</div>
                            <div className="f11-400 opacity5 pr-5">
                              ( RSVP is kept for stipulated time after Event
                              Starts and Auto cancelled )
                            </div>
                          </div>
                          <div className="col-5">
                            <div className="row align-items-center">
                              <div className="col-8 p-0">
                                <FormControl
                                  variant="outlined"
                                  className={"w-100"}
                                >
                                  <Select
                                    // label="Minutes"
                                    name="rsvp_kept_for"
                                    id="rsvp_kept_for"
                                    className={`w-100 ${
                                      formik.errors.rsvp_kept_for &&
                                      formik.touched.rsvp_kept_for
                                        ? "enError outlined-Minutes"
                                        : "outlined-Minutes"
                                    }`}
                                    disabled={disabled}
                                    onChange={formik.handleChange}
                                    value={formik.values.rsvp_kept_for}
                                    onBlur={formik.handleBlur}
                                    isInvalid={
                                      formik.errors.rsvp_kept_for &&
                                      formik.touched.rsvp_kept_for
                                    }
                                    // className="outlined-Minutes"
                                    IconComponent={KeyboardArrowDownIcon}
                                  >
                                    <MenuItem value={0}>00 Minute</MenuItem>
                                    <MenuItem value={5}>05 Minute</MenuItem>
                                    <MenuItem value={10}>10 Minute</MenuItem>
                                    <MenuItem value={15}>15 Minute</MenuItem>
                                    <MenuItem value={20}>20 Minute</MenuItem>
                                    <MenuItem value={30}>30 Minute</MenuItem>
                                  </Select>
                                </FormControl>
                              </div>
                              <div className="col-4">
                                <p className="f12-500">Minutes</p>
                              </div>
                              <div className="col-8">
                                {formik.errors.rsvp_kept_for &&
                                formik.touched.rsvp_kept_for ? (
                                  <div className="pho_14_regular text-danger">
                                    {formik.errors.rsvp_kept_for}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="row margin-between-toggler">
                          <div className="col-7">
                            <div className="f15-700">Auto Cancel</div>
                            <div className="f11-400 opacity5 pr-5">
                              Pending Orders have to be accepted within
                              Specified period Otherwise it will be cancelled
                            </div>
                          </div>
                          <div className="col-5">
                            <div className="row align-items-center">
                              <div className="col-8 p-0">
                                <FormControl
                                  variant="outlined"
                                  className={"w-100"}
                                >
                                  <Select
                                    // label="Minutes"
                                    name="auto_cancel"
                                    id="auto_cancel"
                                    className={`w-100 ${
                                      formik.errors.auto_cancel &&
                                      formik.touched.auto_cancel
                                        ? "enError outlined-Minutes"
                                        : "outlined-Minutes"
                                    }`}
                                    disabled={disabled}
                                    onChange={formik.handleChange}
                                    value={formik.values.auto_cancel}
                                    onBlur={formik.handleBlur}
                                    isInvalid={
                                      formik.errors.auto_cancel &&
                                      formik.touched.auto_cancel
                                    }
                                    // className="outlined-Minutes"
                                    IconComponent={KeyboardArrowDownIcon}
                                  >
                                    <MenuItem value={5}>05 Minute</MenuItem>
                                    <MenuItem value={10}>10 Minute</MenuItem>
                                    <MenuItem value={15}>15 Minute</MenuItem>
                                  </Select>
                                </FormControl>
                              </div>
                              <div className="col-4">
                                <p className="f12-500">Minutes</p>
                              </div>
                              <div className="col-8">
                                {formik.errors.auto_cancel &&
                                formik.touched.auto_cancel ? (
                                  <div className="pho_14_regular text-danger">
                                    {formik.errors.auto_cancel}
                                  </div>
                                ) : null}
                              </div>
                            </div>
                            {/* <FormControl variant="outlined" className={"w-100"}>
                              <InputLabel htmlFor="outlined-Minutes">                              
                              </InputLabel>
                              </FormControl> */}
                          </div>
                        </div>
                      </div>
                    ) : null}
                  </div>
                  <hr />
                  <div className="row margin-between-toggler">
                    <div className="col-12">
                      <div className="f20-700 pb-3 mt-2">
                        Do you want to use Table/Seat Management for Events ?
                      </div>
                    </div>
                    <div className="col-8">
                      <div className="f15-500 rsvp-setting-text">
                        Enable Table or Seat Management for your events
                      </div>
                    </div>
                    <div className="col-4">
                      <ToggleButtonWithYesNo
                        activeClass={formik.values.tableSeatManagement}
                        checkedBox={formik.values.tableSeatManagement}
                        onChange={() =>
                          formik.setFieldValue(
                            "tableSeatManagement",
                            !formik.values.tableSeatManagement
                          )
                        }
                        disabled={disabled}
                        extraClass="d-flex align-items-center"
                        extraYesNo="f12-500"
                      />
                    </div>
                    {formik.values.tableSeatManagement ? (
                      <div className="col-12 mt-3">
                        <button
                          className="f15-500 btn rsvp-setting-button p-0"
                          style={{ color: "#EE3A23" }}
                        >
                          Set Up Banquet and Event Area with Tables/Seats
                        </button>
                      </div>
                    ) : null}
                  </div>
                </div>
                <div className="onboarding-map-setup-screen-autodetect-button mt-5 mb-4">
                  <ReusableOnboardingLink
                    buttonTitle="Back Button"
                    buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_white"
                    buttonText="Back"
                    link="/edit-event-subscription"
                  />
                  {!disabled && (
                    <ReusableOnboardingButton
                      buttonTitle="Next Button"
                      buttonClass="onboarding_button_link_reusable onboarding_button_link_reusable_red ml-3"
                      buttonText="Done"
                      buttonType="button"
                      onClick={() => onClickSave()}
                    />
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </React.Fragment>
    );
  }
};

OfflineEventsEditSubscription.propTypes = {
  auth: PropTypes.object.isRequired,
  subscription: PropTypes.object.isRequired,
  subscriptionData: PropTypes.object.isRequired,
};

const mapStateToProps = (state) => ({
  auth: state.auth,
  subscription:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,

  /************* Active Service ************/
  casualDiningService:
    state?.onboarding?.onboard_subscription_details?.casual_dining,
  // fastFoodDiningService:
  //   state?.onboarding?.onboard_subscription_details?.fast_food_dining,
  multiDiningService:
    state?.onboarding?.onboard_subscription_details?.multi_service_business,
  /************* Subscription Data ************/
  subscriptionData:
    state?.onboarding?.onboard_subscription_details?.casual_dining &&
    state?.onboarding?.onboard_subscription_details?.casual_dining_status
      ? state?.onboarding?.onboard_subscription_details?.casual_dining_status
          ?.event_management?.offline_event
      : state?.onboarding?.onboard_subscription_details
          ?.multi_service_business_status?.event_management?.offline_event,
  /************* All SubscriptionsData Data ************/
  allSubscriptionsData:
    state?.onboarding && state?.onboarding?.onboard_subscription_details,
});

export default connect(mapStateToProps, {
  update_new_subscription_for_vendor,
})(withRouter(OfflineEventsEditSubscription));
